var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRegistarationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    viewBox: "0 0 48 48",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    enableBackground: "new 0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m36,0l-21,21-6,18 18-6 21-21-12-12zm-21,33l3-9 6,6-9,3zm12-6l-6-6 9-9 6,6-9,9zm15-.516l6-6v18.516c0,4.971-4.029,9-9,9h-30c-4.971,0-9-4.029-9-9v-30c0-4.971 4.029-9 9-9h18.516l-6,6h-12.516c-1.659,0-3,1.341-3,3v30c0,1.659 1.341,3 3,3h30c1.659,0 3-1.341 3-3v-12.516Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegistarationIcon);
export default __webpack_public_path__ + "static/media/registaration_icon.d470025f0d2a049feb3b224658010714.svg";
export { ForwardRef as ReactComponent };